import { ProSettings } from '@ant-design/pro-components'

export default {
  siderWidth: 224,
  contentWidth: 'Fluid',
  layout: 'mix',
  fixSiderbar: true,
  pwa: false
} as ProSettings
